import React from 'react';
import { ModalClosed, ModalSuccess } from '~misc/icons';
import { Link } from 'react-router-dom';
import './index.scss';
import useHeader from '~components/Header/hooks/useHeader';

const StatusModal = ({ isOpen, onClose, title, sub, buttonOne, linkOne, isLinkRedirect = false }) => {
  const modalClasses = isOpen ? 'fixed inset-0 bg-black bg-opacity-50 z-[99999]' : 'hidden';
  const overlayClasses = isOpen ? 'fixed inset-0 bg-black opacity-50 z-40' : 'hidden';
  const { path } = useHeader();
  const edittabeladepreco = /tabela-preco\/negociacao\/(\d+)/;
  return (
    <div className={modalClasses}>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative" data-test-id="modal-success-message">
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
            >
              <ModalClosed />
            </button>
          </div>
          <ModalSuccess />
          <h3 className="font-bold text-3xl max-w-[400px]" data-test-id="success-message-text">
            {title}
          </h3>
          <h4 className="mt-2">{sub}</h4>
          <div className="flex justify-center gap-3 mt-3">
            {path == '/carteira/prospect/novo' || isLinkRedirect || path?.match(edittabeladepreco) ? (
              <Link to={linkOne}>
                <button
                  type="button"
                  className="px-6 py-3 rounded bg-quaternaria text-white font-bold  hover:bg-white hover:text-quaternaria border-2 border-quaternaria border-quartenaria transition duration-300 ease-in-out"
                  onClick={onClose}
                >
                  {buttonOne}
                </button>
              </Link>
            ) : (
              <button
                type="button"
                className="px-6 py-3 rounded bg-quaternaria text-white font-bold  hover:bg-white hover:text-quaternaria border-2 border-quaternaria border-quartenaria transition duration-300 ease-in-out"
                onClick={onClose}
              >
                {buttonOne}
              </button>
            )}
          </div>
        </div>
        <div className={overlayClasses} onClick={onClose}></div>
      </div>
    </div>
  );
};

export default StatusModal;
